import { Link } from "react-router-dom";
import {useEffect, useState} from "react";
import {getCMSAssets} from "../../utils/cms.utils";

const BreadCrumb = ({ title, items = [] }) => {
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setAssets(getCMSAssets());
    }, []);

    return (
        <div
            className="breadcrumb__area"
            style={{ backgroundImage: `url(${assets?.breadcrumb_banner})` }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="breadcrumb__area-content">
                            <h2>{title}</h2>

                            <ul className="breadcrumb__list">
                                <li>
                                    <Link to="/">Home</Link>
                                    <i className="fa-regular fa-angle-right" />
                                </li>

                                {items.map((item, index) => {
                                    const isLast = index === items.length - 1;

                                    return (
                                        <li key={index}>
                                            {item.to && !isLast ? (
                                                <>
                                                    <Link to={item.to}>
                                                        {item.label}
                                                    </Link>
                                                    <i className="fa-regular fa-angle-right" />
                                                </>
                                            ) : (
                                                <span>{item.label}</span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreadCrumb;
